import ProductImage from '~/components/ProductImage';
import { Product } from './exchangeOptions';

export default function ProductDisplay({
  product,
  banner,
  onSelect: onClick,
}: {
  product: Product;
  onSelect?: () => void;
  banner?: string | null;
}) {
  return (
    <button
      type="button"
      className="group flex flex-col items-center gap-2 outline-hidden"
      onClick={onClick}
    >
      {/* // TODO re-evaluate the styling of the hover state, to see if it should use the same clarity as the focus state */}
      <div className="relative aspect-square h-full max-h-40 min-h-20 w-full max-w-40 min-w-20 rounded-sm ring-primary ring-offset-2 transition-shadow group-focus-within:ring-2 group-hover:shadow-md">
        <ProductImage
          variant="full"
          alt={product.name}
          src={product.imageUrl}
        />
        {banner && (
          <p className="absolute right-0 bottom-0 left-0 rounded-b bg-black/70 p-1 text-center text-xs break-words text-white">
            {banner}
          </p>
        )}
      </div>
      <p className="text-center text-xs font-medium text-gray-900">
        {product.name}
      </p>
    </button>
  );
}
